export const GET_MAINTENANCE_MODE = 'GET_MAINTENANCE_MODE';

/**
 * Get maintenance mode.
 * @function getMaintenanceMode
 * @param {Object} data Data.
 * @returns {Object} Get maintenance mode results action.
 */
export function getMaintenanceMode() {
  return {
    type: GET_MAINTENANCE_MODE,
    request: {
      op: 'get',
      path: `/@checkMaintenance`,
    },
  };
}
